import React, { useContext } from "react";
import Logo from "../../Assets/Images/avatar-new.jpg";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import styled from "styled-components";

const StyledImage = styled.img`
  width: 35px;
  aspect-ratio: 1/1;
  border-radius: 100%;
  padding-right: 0 !important;
  margin-right: 5px;
`;

const Profile = () => {
  let navigate = useNavigate();
  const { setIsLoggedIn, profileData:userData } = useContext(UserContext);
  let user = userData;
  const handleLogOut = () => {
    localStorage.removeItem("_2mseamlessTailoring");
    localStorage.removeItem("_2mseamlessTailoring_Profile");
    setIsLoggedIn(false);
    window.location.reload()
  };

  return (
    <span className="profile_div mt-1">
      <Dropdown>
        <Dropdown.Toggle variant="" id="dropdown-basic">
          <span className="title-span ">
            <StyledImage
              alt="img"
              src={user?.image_url ? user?.image_url : Logo}
            />
            <span className="ml-2">{user?.first_name}</span>
            <i className="fa-solid fa-caret-down"></i>
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => navigate("/laundry/laundryhistory")}
            href=""
          >
            View Profile
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogOut}>Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </span>
  );
};

export default Profile;
